import FJAppConstant from '../../constants/FJAppConstant';
import { LOCAL } from '../../constants/FJEvnConstant';
import FJVersionConfig from '../FJVersionConfig';

const environment = import.meta.env.MODE;

export default {
    resultImageKey: 'ai/export/remove-background/',
    originalImageKey: 'ai/input/remove-background/',
    historyListType: 15,
    appType: FJAppConstant.PHOTO_REMOVE_BG,
    currentMenuName: 'ai-image-bg-remover',
    freeLimitType: 'image-background-remove',
    autoFreeLimitType: 'auto-image-background-remove',
    notImageBoxTitle: 'quickly-remove-image-background-with-ai',
    notImageBoxDesc: 'quickly-remove-image-background-with-ai-desc',
    notImageBoxBgUrl:
        environment === LOCAL
            ? `/public/img/photoRemoveBg/bg.png?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/photoRemoveBg/bg.png?v=${FJVersionConfig.staticPathVersion}`,
    notImageBoxVideoUrl:
        environment === LOCAL
            ? `/public/img/photoRemoveBg/video.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/photoRemoveBg/video.mp4?v=${FJVersionConfig.staticPathVersion}`,

    quickSelectionTipVideoUrl:
        environment === LOCAL
            ? `/public/img/photoRemoveBg/quick_selection_tips.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/photoRemoveBg/quick_selection_tips.mp4?v=${FJVersionConfig.staticPathVersion}`,
    quickSelectionTipImgUrl:
        environment === LOCAL
            ? `/public/img/photoRemoveBg/quick_selection_tips.png?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/photoRemoveBg/quick_selection_tips.png?v=${FJVersionConfig.staticPathVersion}`,
    backgroundPhotoListJsonPath:
        environment === LOCAL
            ? `/public/preloadData/photoRemoveBg/backgroundList.json?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/preloadData/photoRemoveBg/backgroundList.json?v=${FJVersionConfig.staticPathVersion}`,
    flexClipBgPhotoThumbnailBaseUrl:
        environment === LOCAL ? `/public/img/photoRemoveBg/thumbnail/` : `/app/ai-tools/img/photoRemoveBg/thumbnail/`,
    flexClipBgPhotoBaseUrl:
        environment === LOCAL ? `/public/img/photoRemoveBg/background/` : `/app/ai-tools/img/photoRemoveBg/background/`,
};
